export default __webpack_public_path__ + "static/media/3M.94870d41.jpg";